import React from "react";
import { CharacterResult } from "common/character/dto/CharacterResult";
import { getSignImagePath } from "common/character/character_common";
import CharacterImage from "../file/CharacterImage";

type CharacterLetterViewProps = {
  character: CharacterResult;
};

const CharacterLetterView = ({ character }: CharacterLetterViewProps) => {
  const signImage: string | null = React.useMemo(() => {
    let signIm: string | null = null;
    if (character) {
      const imagePath = getSignImagePath(character);
      if (imagePath) {
        signIm = imagePath;
      }
    }
    return signIm;
  }, [character]);

  return (
    <>
      {signImage && (
        <CharacterImage characterFile={{ path: signImage }} small />
      )}
      {!signImage && character.letter}
    </>
  );
};

export default CharacterLetterView;
